import { formatDistanceToNowStrict } from "date-fns";
import { enUS, es } from "date-fns/locale";

const locales = { en: enUS, es } as const;
export type FormatTimeLocale = keyof typeof locales;

export function resolveLocale(language: string): FormatTimeLocale {
  return language.toLowerCase().startsWith("es") ? "es" : "en";
}

export function formatRelativeFromNow(iso: string, language: string): string {
  return formatDistanceToNowStrict(new Date(iso), {
    locale: locales[resolveLocale(language)],
  });
}
